/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/26/22
 */

import React from "react";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@mui/material";
import {EventSubscriptionMessageFormat} from "../../interfaces/Global";

export interface MessageFormatSelectorProps {
	format: EventSubscriptionMessageFormat
	setFormat: (format: EventSubscriptionMessageFormat) => void
}

export default function MessageFormatSelector(props: MessageFormatSelectorProps) {

	return (
		<FormControl variant={"standard"}>
			<InputLabel>Message Format</InputLabel>
			<Select
				value={props.format}
				onChange={(event) => {
					const value = event.target.value as EventSubscriptionMessageFormat;
					props.setFormat(value);
				}}
			>
				<MenuItem value={"compact"}>Compact</MenuItem>
				<MenuItem value={"standard"}>Standard</MenuItem>
				<MenuItem value={"complete"}>Complete</MenuItem>
			</Select>
			<FormHelperText>
				{props.format === "compact" && "One-liners when possible, for minimal notification footprint."}
				{props.format === "standard" && "Most of event information will be included in a notification."}
				{props.format === "complete" && "All event information will be included in a notification."}
			</FormHelperText>
		</FormControl>
	);

}